import * as React from "react";
interface props {
  className?: string;
}
const MessageSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    className={className}
    fill="none"
    viewBox="0 0 38 38"
  >
    <path
      fill="#262626"
      d="M32.063 5.938H5.936a2.375 2.375 0 0 0-2.375 2.375v21.374a2.375 2.375 0 0 0 2.376 2.375h26.125a2.375 2.375 0 0 0 2.374-2.374V8.313a2.375 2.375 0 0 0-2.374-2.376m-5.938 19h-14.25a1.188 1.188 0 0 1 0-2.375h14.25a1.188 1.188 0 0 1 0 2.375m0-4.75h-14.25a1.188 1.188 0 0 1 0-2.375h14.25a1.188 1.188 0 0 1 0 2.375m0-4.75h-14.25a1.188 1.188 0 0 1 0-2.376h14.25a1.188 1.188 0 0 1 0 2.376"
    ></path>
  </svg>
);

export default MessageSvg;
